import { render } from "./MailingMailTemplateOverviewItem.vue?vue&type=template&id=3ae1e605&scoped=true&ts=true"
import script from "./MailingMailTemplateOverviewItem.vue?vue&type=script&lang=ts"
export * from "./MailingMailTemplateOverviewItem.vue?vue&type=script&lang=ts"

import "./MailingMailTemplateOverviewItem.vue?vue&type=style&index=0&id=3ae1e605&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae1e605"]])

export default __exports__